import { Link } from 'react-router-dom';
import { serviceCategories } from '../pages/services/serviceCategories';
import { MapPin, Phone, Mail } from 'lucide-react';
import logo from '../assets/logo.png';

export default function Footer({ openEnquiry }) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src={logo} alt="Kodefactor" className="footer__logo-img" />
              <span className="brandmark brandmark--footer">
                <span className="brandmark__name">Kodefactor</span>
                <span className="brandmark__sub">Consulting Pvt. Ltd.</span>
              </span>
            </Link>
            <p>Expert IT consulting and digital transformation for businesses ready to scale. Cloud, security, DevOps, AI, we do it all.</p>            
            <p className="footer__address">
              <MapPin size={16} /> Baner, Pune India 411 045</p>
          </div>

          <div>
            <div className="footer__col-title">Services</div>
            <ul className="footer__links">
              {serviceCategories.map((c) => (
                <li key={c.slug}><Link to={`/services/${c.slug}`}>{c.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="footer__col-title">Company</div>
            <ul className="footer__links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/process">Process</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <div className="footer__col-title">Contact</div>
            <ul className="footer__links">
              <li>
                <a href="tel:+12135790442" className="footer__contact-item">
                  <Phone size={16} />
                  <span>+1 (213) 579-0442</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@kodefactor.io" className="footer__contact-item">
                  <Mail size={16} />
                  <span>info@kodefactor.io</span>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/kodefactorconsulting" target="_blank" rel="noopener noreferrer" className="footer__contact-item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" style={{ color: 'var(--blue)' }}>
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  <span>LinkedIn</span>
                </a>
              </li>
              <li>
                <button onClick={() => openEnquiry('Footer')} className="btn btn--primary footer__cta-btn">
                  Book a Call
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copy">© {new Date().getFullYear()} Kodefactor Consulting Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
